@if (isAuthenticated$ | async) {
  <h6 class="dropdown-header" i18n>Appearance</h6>
  @for (option of options; track option.mode) {
    <button
      type="button"
      class="dropdown-item d-flex align-items-center"
      [class.active]="themeService.mode() === option.mode"
      (click)="setAppearance(option.mode)"
    >
      <i class="fa {{ option.iconClass }} me-2"></i>
      {{ option.label }}
      @if (themeService.mode() === option.mode) {
        <i class="fa fa-check ms-auto ps-2"></i>
      }
    </button>
  }
}
